import { featuredPicks } from "@/mocks/home";
import SectionHeading from "./SectionHeading";

export default function FeaturedPicks() {
  return (
    <section id="featured" className="w-full bg-background-100 px-4 py-10 md:px-6 md:py-14">
      <div className="mx-auto max-w-[1280px]">
        <SectionHeading
          eyebrow="Editor's Picks"
          title="高分神作榜 · 本周编辑精选"
          desc="综合评分、读者口碑与叙事完成度筛选出的三部代表作品，是多数人入坑和补番的首选。"
          actionText="更多高分神作"
        />

        <div className="grid grid-cols-1 gap-5 md:grid-cols-3 md:gap-6">
          {featuredPicks.map((pick, i) => (
            <article
              key={pick.id}
              className={`group flex flex-col overflow-hidden rounded-lg border border-background-200 bg-background-50 transition-all hover:-translate-y-1 hover:border-primary-300 ${
                i === 0 ? "md:ring-1 md:ring-primary-200" : ""
              }`}
            >
              <div className="relative h-60 w-full overflow-hidden md:h-72">
                <img
                  src={pick.cover}
                  alt={`${pick.title} 韩国漫画封面`}
                  title={`${pick.title} 高分韩国漫画推荐`}
                  className="h-full w-full object-top transition-transform duration-500 group-hover:scale-105"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-foreground-950/85 via-foreground-950/10 to-transparent" />
                <span className="absolute left-4 top-4 font-heading text-3xl font-bold text-background-50/90">
                  {pick.rank}
                </span>
                <span className="absolute right-4 top-4 flex items-center gap-1 rounded-full bg-accent-500 px-2.5 py-1 text-xs font-bold text-foreground-950">
                  <i className="ri-star-fill text-[11px]" />
                  {pick.score}
                </span>
                <div className="absolute bottom-4 left-4 right-4">
                  <h3 className="font-heading text-xl font-bold text-background-50">{pick.title}</h3>
                  <p className="mt-1 text-xs text-background-300">{pick.author}</p>
                </div>
              </div>

              <div className="flex flex-1 flex-col p-5">
                <div className="flex flex-wrap items-center gap-2">
                  <span className="rounded-full bg-primary-100 px-2.5 py-0.5 text-[11px] font-semibold text-primary-700">
                    {pick.status}
                  </span>
                  <span className="text-xs text-foreground-500">{pick.genre}</span>
                </div>

                <p className="mt-3 flex-1 text-sm leading-relaxed text-foreground-700">{pick.summary}</p>

                <div className="mt-4 flex flex-wrap gap-1.5">
                  {pick.tags.map((tag) => (
                    <span
                      key={tag}
                      className="rounded-full border border-background-300 px-2.5 py-0.5 text-[11px] text-foreground-600"
                    >
                      #{tag}
                    </span>
                  ))}
                </div>

                <button
                  type="button"
                  className="mt-5 inline-flex items-center justify-center gap-1.5 whitespace-nowrap rounded-md bg-foreground-950 px-4 py-2.5 text-sm font-semibold text-background-50 transition-colors hover:bg-primary-600 cursor-pointer"
                >
                  <i className="ri-book-open-line text-base" />
                  查看作品详情
                </button>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}